import React from "react";
import Img from "images/benifitsection.png";

type CardProps = {
  title: string;
  description: string;
  className?: string;
};

const BenefitsSection: React.FC = () => {
  return (
    <section className="bg-black text-white p-8">
      <div className="max-w-6xl mx-auto grid grid-col-1 lg:grid-cols-2 gap-8 items-start">
        <div>
          <h2 className="text-3xl font-bold mb-6">Where Are You Going?</h2>
          <div className="rounded-lg overflow-hidden">
            <img src={Img} alt="" className="w-full h-auto" />
          </div>
        </div>

        <div className="flex flex-wrap gap-4">
          <div className="w-[48%] translate-y-12">
            <Card
              title="Pick-Up Location"
              description="Choose the most convenient location for you."
            />
          </div>
          <div className="w-[48%]">
            <Card
              title="Drop-Off Options"
              description="Same drop-off or a different location—it's up to you!"
            />
          </div>
          <div className="w-[48%] translate-y-12">
            <Card
              title="Add Dates"
              description="Customize your rental with pick-up and drop-off times."
            />
          </div>
          <div className="w-[48%]">
            <Card
              title="Pick-Up – Drop-Off"
              description="10:00 AM - 05:00 PM"
              className="bg-gradient-to-r from-[#18cc3c2b]  to-[#1674d313]"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

const Card: React.FC<CardProps> = ({ title, description, className }) => {
  return (
    <div
      className={`bg-transparent p-6 rounded-lg border border-[#18CC3D] shadow-md flex flex-col justify-between min-h-60 ${className}`}
    >
      <div className="space-y-4">
        <div>
          <svg
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="28" cy="28" r="28" fill="white" />
            <circle
              cx="28"
              cy="28.4102"
              r="10"
              fill="url(#paint0_linear_2081_26241)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_2081_26241"
                x1="14.3614"
                y1="13.8948"
                x2="44.869"
                y2="19.5668"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#18CC3D" />
                <stop offset="1" stop-color="#00A8F3" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <div>
          <h3 className="text-lg font-semibold">{title}</h3>

          <p className="text-gray-400">{description}</p>
        </div>
      </div>
    </div>
  );
};

export default BenefitsSection;
